import { ref } from 'vue';


const is_enabled = ref( false );
const is_console_enabled = ref( false );

const items = ref(
{
	service:
	{
		performance: [],
		errors: []
	},
	security:
	{
		token: [],
		user: []
	}
} );


export const Service = {};
export const Security = {};


export function Enable ()
{
	is_enabled.value = true;
}


export function Disable ()
{
	is_enabled.value = false;
}


export function Is_enabled ()
{
	return is_enabled.value;
}


export function Clear ()
{
	items.value.service.performance = [];
	items.value.service.errors = [];
}


export function Console ( context, data = null )
{
	if ( !is_console_enabled.value )
		return;
	
	console.log( context );
	
	if ( data !== null )
		console.log( data );
}


Service.Errors =
{
	
	Add: ( type, code, message ) =>
	{
		if ( is_enabled.value )
			items.value.service.errors.push( { datetime: new Date(), type: type, code: code, message: message } );
	},
	
	
	Get: () => items.value.service.errors,
	Clear: () => items.value.service.errors = []
};


Service.Performance =
{
	Add: ( endpoint, duration ) =>
	{
		if ( is_enabled.value )
			items.value.service.performance.push( { datetime: new Date(), endpoint: endpoint, duration: duration } );
	},
	
	
	Get: () => items.value.service.performance,
	Clear: () => items.value.service.performance = []
};


Security.Token =
{
	Add: ( operation, result ) =>
	{
		if ( is_enabled.value )
			items.value.security.token.push( { datetime: new Date(), operation: operation, result: result } );
	},
	
	Get: () => items.value.security.token,
	Clear: () => items.value.security.token = []
};


Security.User =
{
	Add: ( operation, parameters, result ) =>
	{
		if ( is_enabled.value )
			items.value.security.user.push( { datetime: new Date(), operation: operation, parameters: parameters, result: result } );
	},
	
	Get: () => items.value.security.user,
	Clear: () => items.value.security.user = []
};
